import { SearchIcon } from "app/components/Icons";
import Input from "app/components/Input";
import React from "react";

interface Props {
  handleSelectAll: () => void;
  setSearchKeyword: (e: string) => void;
  isAllSelected: boolean;
  searchKeyword: string;
  isHeader: string;
  searchPlaceholder: string;
  tags: number;
}

const Search: React.FC<Props> = ({
  handleSelectAll,
  isAllSelected,
  searchKeyword,
  setSearchKeyword,
  isHeader,
  searchPlaceholder,
  tags,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between px-4 py-3 text-secondary tracking-[0.56px] text-sm font-semibold leading-[21px] uppercase border-b border-[#E9ECF2]">
        {isHeader && <span>{isHeader}</span>}
        {tags >= 0 && (
          <div className="flex items-center gap-2">
            <button
              className="text-primary text-sm font-medium focus:outline-none text-[#5A8DF1] "
              onClick={handleSelectAll}
            >
              {isAllSelected ? "Unselect All" : "Select All"}
            </button>
          </div>
        )}
      </div>
      <Input
        noBorder
        id={searchKeyword ?? "search"}
        icon={<SearchIcon size="17" color="#79808A" />}
        placeholder={searchPlaceholder ?? "Search by tag name"}
        value={searchKeyword}
        onChange={(e) => {
          e.stopPropagation();
          setSearchKeyword(e.target.value);
        }}
        innerContainerClassName="px-2 border-b-[1px] border-[#E9ECF2]"
      />
    </div>
  );
};

export default Search;
